// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 653) return "static/css/653.b67b3efab2ce9632c1a0.lib.css";
	if (chunkId === 678) return "static/css/678.561c96bb87fcb6272388.css";
	// return url for filenames based on template
	return undefined;
};